import React from 'react';
import { Scale } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function CostComparison() {
  const comparisons = [{
    without: 'Noches sin dormir pensando qué hacer',
    cost: 'Energía, salud y paz mental'
  }, {
    without: 'Improvisar en cada crisis',
    cost: 'Errores que alejan más a tu hijo/a'
  }, {
    without: 'Ciclo de pelea y silencio sin fin',
    cost: 'La adolescencia pasa y no vuelve'
  }, {
    without: 'Buscar en Google a las 2am',
    cost: 'Información contradictoria que confunde'
  }, {
    without: 'Seguir sin herramientas',
    cost: 'Una distancia que se vuelve permanente'
  }];
  return <section className="py-24 relative" data-id="element-38">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-39">
        <FadeIn data-id="element-40">
          <div className="text-center mb-16" data-id="element-41">
            <Scale className="w-12 h-12 text-gray-500 mx-auto mb-6" data-id="element-42" />
            <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-43">
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-44">
          <div className="bg-surface rounded-2xl border border-white/5 overflow-hidden mb-6" data-id="element-45">
            <div className="grid grid-cols-2 bg-surfaceLight p-4 md:p-6 border-b border-white/5" data-id="element-46">
              <div className="font-bold text-gray-400 uppercase tracking-wider text-sm md:text-base" data-id="element-47">
                Sin Kit Adulto de Rescate
              </div>
              <div className="font-bold text-red-400 uppercase tracking-wider text-sm md:text-base pl-4 md:pl-6 border-l border-white/5" data-id="element-48">
                Costo real
              </div>
            </div>

            <div className="divide-y divide-white/5" data-id="element-49">
              {comparisons.map((item, i) => <div key={i} className="grid grid-cols-2 p-4 md:p-6 hover:bg-white/[0.02] transition-colors" data-id="element-50">
                  <div className="text-gray-300 pr-4" data-id="element-51">{item.without}</div>
                  <div className="text-red-300/80 pl-4 md:pl-6 border-l border-white/5 font-medium" data-id="element-52">
                    {item.cost}
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-53">
          <div className="mt-16 text-center max-w-3xl mx-auto" data-id="element-54">
            <p className="text-xl md:text-2xl text-gold font-bold mb-6" data-id="element-55">
              Esta noche puede ser diferente.
            </p>
            <p className="text-lg text-gray-300 italic" data-id="element-56">
              🛡️ "La adolescencia no espera. Pero tampoco es tarde."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}